
import React, { ChangeEvent, useState } from 'react'

import Typography from '@mui/material/Typography'
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Cancel from './../../../../assets/icons/close.png'
import AutoCompleteMultiSelect from '../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx'
import TextAreaComponents from '../../../components/TextAreaComponents/TextAreaComponents.tsx'
import previewImg from './../../../../assets/icons/preview.png'
import './ImportSpecification.css'
import SpecificationPreview from './SpecificationPreview/SpecificationPreview.tsx'

function ImportSpecification(props) {
    const handleClose = () => {
        props.onHandleAddItem(false)
    }
    const sectionDatas = [
        { id: 1, title: 'Pot Kettle Black London' },
        { id: 2, title: 'Pot Kettle Black London' }
    ]
    const [autoCompleteValue, setAutoCompleteValue] = React.useState([])
    const addValue = (props) => {
        setAutoCompleteValue(props)
    }
    const itemDatas = [
        { id: 1, title: 'Burger (In-Store Menu)' },
        { id: 2, title: 'Burger (Online)' },
        { id: 2, title: 'Pizza (In-Store Menu)' }
    ]
    const searchResults = [
        {
            id: 1, section: 'Sauces', itemName: "Burger", restaurantName: "PKB Manchester", ischeck: false
        },
        { id: 2, section: 'Portion', itemName: "Burger", restaurantName: "PKB Manchester", ischeck: false },
        { id: 3, section: 'Sauces', itemName: "Burger", restaurantName: "PKB London", ischeck: false },
        { id: 4, section: 'Portion', itemName: "Burger", restaurantName: "PKB London", ischeck: false }
    ]

    // const [autoCompleteValue, setAutoCompleteValue] = React.useState([])
    const addItem = (props) => {
        setAutoCompleteValue(props)
    }
    const [resultDataTable, setresultDataTable] = React.useState([])
    const [selectedDatas, setselectedDatas] = React.useState([])
    const textFieldValue = (props) => {
        let data = searchResults.filter(x => x.itemName.toLowerCase().includes(props.toLowerCase()) || x.restaurantName.toLowerCase().includes(props.toLowerCase()) || x.section.toLowerCase().includes(props.toLowerCase()))
        setresultDataTable(data);

    }
    const selectData = (props) => {
        console.log(props)
        if (selectedDatas.length > 0) {
            let alreadySelected = selectedDatas.find(x => x.id === props.id);
            if (alreadySelected != undefined) {
                selectedDatas.pop(alreadySelected);
            }
            else {
                selectedDatas.push(props);
            }
        }
        else {
            selectedDatas.push(props);
        }
    }
    const [previewDatas, setpreviewDatas] = React.useState({})
    const [togglePreview, settogglePreview] = React.useState(false)
    const openPreview = (props) => {
        console.log("Props: " + props);
        setpreviewDatas(true);
        settogglePreview(true);
        setpreviewDatas(props);
        console.log("previewDatas: " + previewDatas);
    }
    const handleAddItem = () => {
        settogglePreview(false);
    }
    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={props.open}
                onClose={handleClose}
            >
                <Grid container>
                    <Grid item xs={6}>
                        <DialogTitle> Import specification</DialogTitle>
                    </Grid>
                    <Grid item xs={6}>
                        <DialogActions>
                            <Button onClick={handleClose}>
                                <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                            </Button>
                        </DialogActions>
                    </Grid>
                </Grid>
                <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                    <div>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={2}>

                            </Grid>
                            <Grid item xs={8} >
                                {/* <AutoCompleteMultiSelect
                                    label={'Select Restaurant Name'}
                                    placeholder={'Select Restaurant Name'}
                                    value={addValue}
                                    datas={sectionDatas}
                                    id={1}
                                /> */}
                                <TextAreaComponents label={'Search By Section - Item - Restaurant'} value={textFieldValue} />
                            </Grid>
                            <Grid item xs={2}>

                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={12}>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>
                                                CheckBox
                                            </th>
                                            <th>
                                                Restaurant name
                                            </th>
                                            <th>
                                                Item Name
                                            </th>
                                            <th>
                                                Section Name
                                            </th>


                                            <th>
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            resultDataTable.map((data, index) => {
                                                return (
                                                    <tr className={`${selectedDatas.find(x => x.id === data.id) ? "selectedData" : ""}`}>
                                                        <td>
                                                            <input type="checkbox" id="vehicle1" name="vehicle1" onChange={(event) => {
                                                                selectData(data)
                                                            }} />
                                                        </td>
                                                        <td>
                                                            {data.restaurantName}
                                                        </td>
                                                        <td>
                                                            {data.itemName}
                                                        </td>
                                                        <td>
                                                            {data.section}
                                                        </td>


                                                        <td>
                                                            <img src={previewImg} alt='' style={{ width: "1.5rem" }} onClick={() => openPreview(data)} />
                                                        </td>

                                                    </tr>
                                                )
                                            })
                                        }
                                        <tr>

                                        </tr>
                                    </tbody>
                                </table>
                            </Grid>

                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={9}></Grid>

                            <Grid item xs={2}>
                                <Button className="AddItemButtons" >
                                    Import
                                </Button>
                            </Grid>
                        </Grid>

                    </div>
                </DialogContent>
            </Dialog>
            <SpecificationPreview open={togglePreview}
                onHandleAddItem={handleAddItem} data={previewDatas} />
        </React.Fragment>

    );
}

export default ImportSpecification;